import { ChurchAccount } from '../models/churchAccount';

export const getAccountText = (account: ChurchAccount): string => {
  const billingAccounts = account.billingAccounts.filter(ba => ba.active);
  if (billingAccounts.length === 0) return 'No account';
  if (billingAccounts.length === 1) return `Account #${billingAccounts[0].accountNumber}`;
  return 'Multiple accounts';
};
